<template>
  <div class="kecheng">
    <kind-choose-view :is-jinpin="false" :show-school="true" :show-kc="false" :type="15" :schoole="schoole" :kind="kind"
      :zy-id="zyId" @isOk="isOk" />

    <div class="kecent">
      <div v-for="item in list" :key="item.id || item.tiitle" class="kecents" @click="imgxq(item)">
        <div v-if="item.isHavePrivateClass === 1" class="tag tagxbk">
          <img src="@/assets/img/smallban/tipss.png" alt="" />
        </div>
        <img class="kecents-img" :src="item.img" alt="课程图片" />
        <div class="kecentsCen" :class="{ boutique: item.productLine === 2 }">
          <div class="kecentsCenTop twoEllipsis">
            {{ item.tiitle }}
          </div>
          <div v-if="item.curForms?.length > 0" class="kecentsCenCen" :class="{ boutiqueTxt: item.productLine === 2 }">
            <span v-for="(curForm, curindex) in item.curForms" :key="curindex" class="cur-form">
              {{ curindex > 0 ? "·" : "" }}{{ curForm }}
            </span>
          </div>
          <div class="kecentsCenBtm">
            <div class="w-b-100">
              <span class="price" :class="{ boutiquePrice: item.productLine === 2 }"><span class="tips">¥ </span>{{
                item.price }}</span>
            </div>
            <div class="more dis_flex">
              <img class="img" src="@/assets/img/Home/Frame.png" object-fit="contain" />
              人气值{{ item.clicks || 0 }}
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="empty-container" v-if="!list || list.length === 0">
      <el-empty description="暂无数据"></el-empty>
    </div>

    <div class="pagination-container">
      <el-pagination class="pagination" :total="total" :current-page="pageNum" :page-sizes="[12, 24, 28, 32]"
        :page-size="pageSize" :pager-count="5" layout="total, sizes, prev, pager, next, jumper"
        @current-change="handleCurrentChange" @size-change="handleSizeChange" />
    </div>
  </div>
</template>
<script>
import { selectPageListToIndex1 } from "@/api/home";
import KindChooseView from "../../components/kindChooseViewktypevipNew.vue";
import { getDomain } from "@/api/cookies";

export default {
  name: "TypeClassNew",
  components: {
    KindChooseView,
  },

  data() {
    return {
      list: [],
      search: {},
      pageSize: 12,
      pageNum: 1,
      total: 0,
      kind: null,
      zyId: null,
      schoole: null,
      domain: null,
    };
  },

  async created() {
    this.domain = getDomain();
    this.initFilterConditions();
    await this.getList();
  },

  methods: {
    initFilterConditions() {
      if (this.$route.query.kind) {
        this.kind = Number(this.$route.query.kind);
        this.search.kind = this.kind;
      }
      if (this.$route.query.zId) {
        this.zyId = Number(this.$route.query.zId);
        this.search.zyId = this.zyId;
      }
      if (this.$route.query.schoole) {
        this.schoole = Number(this.$route.query.schoole);
        this.search.school = this.schoole;
      }
    },

    async getList() {
      const loading = this.$loading({
        lock: true,
        text: "加载中",
        spinner: "",
        background: "rgba(0, 0, 0, 0.2)",
      });

      try {
        const res = await selectPageListToIndex1(
          this.pageSize,
          this.pageNum,
          this.search.school,
          this.search.kind,
          this.search.zyId,
          this.search.type,
          this.search.productLine ? this.search.productLine == '6' ? undefined : this.search.productLine : undefined,
          this.search.areaId !== 1 ? this.search.areaId : undefined,
          this.search.name
        );

        res.rows.forEach((item) => {
          if (item.curForms) {
            item.curForms = item.curForms.split(",");
          }
        });

        this.list = res.rows || [];
        this.total = res.total || 0;
      } finally {
        loading.close();
      }
    },

    handleSizeChange(val) {
      this.pageSize = val;
      this.pageNum = 1;
      this.getList();
    },

    handleCurrentChange(val) {
      this.pageNum = val;
      this.getList();
    },

    isOk(val) {
      this.search = val;
      this.pageNum = 1;
      this.getList();
    },

    imgxq(item) {
      if (!item || !item.id) return;
      if (item.productLine == 3) {
        const routeUrl = this.$router.resolve({
          path: '/VIP/VIPClassxq',
          query: {
            id: item.id
          }
        })
        window.open(routeUrl.href, '_blank')
      } else {
        const routeUrl = this.$router.resolve({
          name: "知识套餐课详情",
          query: {
            id: item.id,
            tenantid: this.search.tenantid,
            type: this.search.type,
            entrantsPrice: item.entrantsPrice,
            jgPrice: item.jgPrice,
          },
        });
        window.open(routeUrl.href, "_blank");
      }


    },
  },
};
</script>
<style lang="less" scoped>
@primary-color: #ff7b1c;
@secondary-color: #ff5e51;
@bg-color: #f5f7fa;
@text-color: #333333;
@border-radius: 8px;
@card-width: 287px;
@card-gap: 24px;
@container-width: 1220px;

.kecheng {
  width: 100%;
  min-height: 100vh;
  background: @bg-color;
  overflow: hidden;
}

.kecent {
  width: calc(@container-width + @card-gap);
  margin: 30px auto 0;
  transform: translateX(-@card-gap / 2);
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
  flex-wrap: wrap;
  background: @bg-color;
}

.kecents {
  width: @card-width;
  background: #ffffff;
  box-shadow: 0 2px 4px 0 rgba(237, 239, 242, 0.7);
  cursor: pointer;
  margin: 0 @card-gap @card-gap 0;
  border-radius: @border-radius;
  position: relative;
  transition: transform 0.2s ease;

  &:hover {
    transform: translateY(-2px);
  }
}

.kecents-img {
  width: 100%;
  height: 161px;
  border-radius: @border-radius @border-radius 0 0;
  cursor: pointer;
  object-fit: cover;
}

.kecentsCen {
  width: 100%;
  height: 150px;
  position: relative;
  padding: 12px 16px 16px;
}

.kecentsCen.boutique {
  height: 158px;
  background-image: url("../../assets/img/Home/boutiqueBan.png");
  background-size: 100% 100%;

  .kecentsCenTop {
    color: #5a4629 !important;
  }

  .more {
    color: #5a4629 !important;
    font-size: 12px !important;
  }
}

.kecentsCenTop {
  font-size: 16px;
  font-family: Microsoft YaHei-Regular, Microsoft YaHei;
  font-weight: 400;
  color: @text-color;
  line-height: 24px;
  height: 48px;
  position: relative;
}

.kecentsCenCen {
  margin-top: 12px;
  height: 20px;
  background-color: #fff2e9;
  border-radius: 2px;
  display: inline-block;
  padding: 0 8px;
  line-height: 20px;
  font-size: 12px;
  font-family: Microsoft YaHei-Regular;
  font-weight: 400;
  color: @primary-color;
}

.kecentsCenCen.boutiqueTxt {
  width: 255px;
  height: 26px;
  line-height: 26px;
  background: none;
  background-image: url("../../assets/img/Home/boutiqueTxt.png") !important;
  background-size: 100% 100%;
  color: #a57800;
}

.kecentsCenBtm {
  position: absolute;
  bottom: 18px;
  left: 16px;
  right: 16px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.price-wrapper {
  width: 100%;
}

.price {
  font-size: 18px;
  font-family: Microsoft YaHei-Regular;
  font-weight: bold;
  color: @secondary-color;
  line-height: 18px;
}

.price.boutiquePrice {
  color: #5a4629 !important;
}

.tips {
  font-size: 14px;
  font-weight: 400;
  line-height: 14px;
}

.more {
  font-size: 16px;
  font-family: Microsoft YaHei-Regular;
  font-weight: 400;
  color: #999999;
  line-height: 16px;
  margin-left: 8px;
  flex-shrink: 0;
  align-items: center;
}

.more .img {
  width: 13px;
  height: 13px;
  margin-right: 5px;
  vertical-align: middle;
}

.cur-form {
  display: inline-block;
}

.empty-container {
  margin: 40px auto;
  text-align: center;
}

.pagination-container {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 30%;
  margin: 40px auto;
  margin-bottom: 80px;
}

.tag {
  position: absolute;
  top: 0;
  left: 0;
}

.tagxbk {
  width: 45px;
  height: 21px;
  line-height: 21px;
  border-radius: 8px 0 8px 0;
  background-size: 45px 21px;
  color: #ffffff;
  text-align: center;
  font-size: 11px;
  position: absolute;
  top: 0;
  left: 0;
}

.tagxbk img {
  transform: translateY(-8px);
  width: 60px !important;
  height: auto !important;
}
</style>
